<template>
    <ls-modal :options="modals.longGrass" @onModalClose="closeModal('longGrass')">
        <div slot="header">
            <h3 class="ls-align--center ls-color--green ls-margin--top-none">Long Grass Policy</h3>
        </div>

        <div class="grid">
            <div class="grid__col-sm-12">
                <p data-font-size="-1">
                    In cases where your grass is overgrown (greater than 6 inches), we often have to
                    charge an additional fee. This compensates the lawn service crew for the
                    additional time it takes to complete the job. Therefore, we reserve the right to
                    charge up to 2x the original price in cases of overgrown grass, although the
                    charge is often much less.
                </p>
                <p data-font-size="-1">
                    In cases where the grass is extremely overgrown (taller than 12 inches), we will
                    get you a custom quote for the completion of the job, as in these cases it often
                    takes much more time and/or specialty equipment.
                </p>
                <p data-font-size="-1">
                    These policies ensure that our hardworking service crews are fairly compensated
                    for the time they spend on each job.
                </p>
            </div>
        </div>

        <div slot="button" class="grid">
            <div class="grid__col-12">
                <div>
                    <button
                        slot="button"
                        class="ls-float-right ls-button ls-button--white"
                        type="button"
                        @click="closeModal('longGrass')"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </ls-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import lsModal from '@/components/original-mydot/modals/modal/Modal.vue';

export default {
    components: {
        lsModal,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(['modals']),
    },
    methods: {
        ...mapActions({
            closeModal: types.MODAL__CLOSE_MODAL,
        }),
    },
};
</script>

<style lang="scss"></style>
